<template>
<div style="background-image: linear-gradient(to bottom,rgba(187, 35, 35, 0.73), rgba(58, 18, 18, 0.73)), url('https://images.pexels.com/photos/207684/pexels-photo-207684.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1');background-size:cover; margin-top: 15px;">
  <!-- <div style="margin-top:-10px;background-color:#F8F8F8">
         <p style="text-align:center;padding-top:15px">
            <span @click="home()" class="hvr txt">Home</span> / <span style="color:#EA0202" class="txt">Universities</span></p>
     </div> -->

     <div class="kolkata5 res">
         <v-layout row wrap class="">
            <v-flex xs12 sm12 md6 lg12 style="text-align:center">
                 <h1 style="padding:25px;color:whitesmoke;">Universities</h1>
            </v-flex>
         </v-layout>
     </div>
      <div class="kolkata5 man">
          <v-layout row wrap class="container" style="margin-top:50px">
              <v-flex xs12 sm12 md6 lg12 >
                  <h1 style="padding:15px;color:whitesmoke;">Universities</h1>
              </v-flex>
          </v-layout>
      </div>
    <v-container>
        <v-layout row wrap  class="my-5" v-if="universitynews.length > 0">

          <v-flex xs12 sm12 md4 class="my-5"  v-for="item in universitynews" :key="item.id">
            <v-card
             
                class="mx-auto"
                style="padding:10px!important"
                max-width="344"
              >
                <v-img
                  :src= item.src
                  height="200px"
                  style="border-radius:50px;"
                  cover
                ></v-img>

                <v-card-title >
                  {{ item.title }}
                </v-card-title>

                <v-card-subtitle  v-html="item.description.slice(0, 150)">
                  
                </v-card-subtitle>

                <v-card-actions>
                  <v-btn
                    color="orange-lighten-2"
                    variant="text"
                    @click="onUni(item)"

                  >
                    Explore
                  </v-btn>

                  <v-spacer></v-spacer>

                  <v-btn
                    :icon="show ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                    @click="show = !show"
                  ></v-btn>
                </v-card-actions>

            
              </v-card>
          </v-flex>


          <!-- <v-flex xs12 sm12 md4 class="my-5">
            <v-card  
                class="mx-auto"
                max-width="344"
              >
              <div style="height:10px ;">
              </div>
                <img
                  src="../../assets/Blogs/UH.jpeg"
                  height="180px"
                  style="border-radius:50px;display: block;margin: auto;padding : 5px;"
                  cover
                  
                />  
                <v-card-title class="my-3">
                  University of Hertfordshire
                </v-card-title>

                <v-card-subtitle style="text-align: justify; height: 150px;"  >
                  "The University of Hertfordshire offers a wide range of Undergraduate, Postgraduate,
                   Professional and Short courses. One of the top 150 universities in the world under 
                   50 years old and only 25 minutes from London."
                </v-card-subtitle>

                <v-card-actions>
                  <v-btn
                    color="orange-lighten-2"
                    variant="text"
                    @click="UniversityDetails()"
                  >
                    Explore
                  </v-btn>

                  <v-spacer></v-spacer>

                  <v-btn
                    :icon="show ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                    @click="show = !show"
                  ></v-btn>
                </v-card-actions>
              </v-card>
          </v-flex> -->
 

        <!-- <v-flex xs12 sm12 md4   class="my-5"> -->
            <!-- <v-card>
                <v-card-title class="kolkata3">
                    <v-avater style="background-color:white;">
                        <img :src=item.src style="height:80px;width:80px;border-radius:50px;" />
                    </v-avater>
                    <v-spacer></v-spacer>
                    <h5 style="text-align:right">{{item.universityName}}</h5>
                </v-card-title>
                <div>
                    <h5 style="padding:20px;">View Details ⇨</h5>
                </div>
            </v-card> -->
        
  <!-- <v-card
    class="mx-auto"
    max-width="344"
   
    style="padding:0px; margin: 10px;"
  >
  <div v-if="item.mysrc!=null">
    <img
    width="100%"
    height="150px"
    :src=item.src 
          
          style="margin:auto; padding:20px;"
          
    />
  </div>
  <div v-if="item.mysrc==null">
    <img
    width="100%"
    height="150px"
    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR7lQIuyO6ulbwHaf5aoYUVJPMFBJwklRH34A&usqp=CAU"
          
    style="margin:auto; padding:20px;"

    />
  </div>
    
    <img style="display:block;margin:auto;" :src="item.src" />
<div style="background-color: #f4f4f4; height:150px
">
    <v-card-title style="font-size:25px; color: #ea0202;">
      {{item.universityName}}
        </v-card-title>

    <v-card-subtitle>
      1,000 miles of wonder
    </v-card-subtitle>

    <v-card-actions>
      <v-btn
        color="#ea0202"
        text
      >
        Explore
      </v-btn>

 
    </v-card-actions>

  </div>

  </v-card> -->


  <!-- <v-card  
                class="mx-auto"
                max-width="344"
              >
              <div style="height:10px ;">
              </div>
                <img
                  src="../../assets/Blogs/UL.jpeg"
                  height="180px"
                  style="border-radius:50px;display: block;margin: auto;"
                  cover
                  
                />
           
                
                <v-card-title class="my-3">
                  University of Leicester
                </v-card-title>

                <v-card-subtitle style="text-align: justify; height: 150px;">
                  University of Leicester is open for September 2023, start applying Please note
                   that applications are open  for the University of Leicester for September 2023,
                    start applying ASAP to grab seats with scholarships up to 5000 GBP           
                       </v-card-subtitle>

                <v-card-actions>
                  <v-btn
                    color="orange-lighten-2"
                    variant="text"
                    @click="UniversityDetails()"
                  >
                    Explore
                  </v-btn>

                  <v-spacer></v-spacer>


                </v-card-actions>
              </v-card>
              
        </v-flex>
        <v-flex xs12 sm12 md4 class="my-5">
            <v-card  
                class="mx-auto"
                max-width="344"
              >
              <div style="height:10px ;">
              </div>
                <img
                src="../../assets/Blogs/Algoma University.jpeg"
                  height="180px"
                  style="border-radius:50px;display: block;margin: auto;"
                  cover
                  
                />  
                <v-card-title class="my-3">
                  Algoma University
                </v-card-title>

                <v-card-subtitle style="text-align: justify; height: 150px;"  >
                  Algoma University, commonly shortened to Algoma U or Algoma, is a public 
                  university with its main campus located in Sault Ste. Marie, Ontario, Canada 
                </v-card-subtitle>

                <v-card-actions>
                  <v-btn
                    color="orange-lighten-2"
                    variant="text"
                    @click="UniversityDetails()"
                  >
                    Explore
                  </v-btn>

                  <v-spacer></v-spacer>

                  <v-btn
                    :icon="show ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                    @click="show = !show"
                  ></v-btn>
                </v-card-actions>
              </v-card>
          </v-flex>
        <v-flex xs12 sm12 md4 class="my-5">
            <v-card  
                class="mx-auto"
                max-width="344"
              >
              <div style="height:10px ;">
              </div>
                <img
                src="../../assets/Blogs/Algoma University.jpeg"
                  height="180px"
                  style="border-radius:50px;display: block;margin: auto;"
                  cover
                  
                />  
                <v-card-title class="my-3">
                  Scholarship
                </v-card-title>

                <v-card-subtitle style="text-align: justify; height: 150px;"  >
                  Many UK higher-education institutions offer their own scholarship programmes.
                   These are offered based on a number of factors, which can be broadly split out 
                   into the following categories: Academic, merit and excellence scholarships...
                </v-card-subtitle>

                <v-card-actions>
                  <v-btn
                    color="orange-lighten-2"
                    variant="text"
                  >
                    Explore
                  </v-btn>

                  <v-spacer></v-spacer>

                  <v-btn
                    :icon="show ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                    @click="show = !show"
                  ></v-btn>
                </v-card-actions>
              </v-card>
          </v-flex> -->
    </v-layout>
    </v-container>
</div>
</template>

<script>
import config from "./../../config.json";
import carousel from 'vue-owl-carousel';
export default {
    components: {
    //GoTop,
    carousel,
  },
  data() {
    return {
      valid: true,
      tab: null,
      isLoading: false,
      universities: [],
      universitynews: []

    };
  },

  mounted() {
    this.axios
      .get(config.API + `news/authors2`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          
          if(element.news.newscategoryId==3) {
            this.universitynews.push({
            id: element.news.id, 
            title: element.news.title,
            description: element.news.description,
            src: config.API1 + 'news/files/' + element.src
            })
          }
        }
      });
  },

  methods: {
    UniversityDetails() {
     this.$router.push("/university-details");

   },
   onUni(item) {
    this.$router.push("/university-details");
    sessionStorage.setItem("unisrc", item.src);
    sessionStorage.setItem("unititle", item.title);
    sessionStorage.setItem("unidescription", item.description);
   },
  }
};
</script>

<style lang="css" scoped>
img.center {
    display: block;
    margin: 0 auto;
}
.kolkata3 {
    background-image: linear-gradient(to bottom,rgba(187, 35, 35, 0.73), rgba(58, 18, 18, 0.73)), url('../../assets/scholarship.png');
    background-size: cover;
    color: white !important;
}
.kolkata5 {
    background-image: linear-gradient(to bottom,rgba(187, 35, 35, 0.73), rgba(58, 18, 18, 0.73)), url('http://www.royalacpaints.com/images/about-us-banner.jpg');
    background-size: cover;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
.mobile-heading {
  font-size: 30px;
}
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
</style>
